<template>
  <div class='systemSet' v-if="permisShow('系统设置')">
    <div class="systemSet_item">
      <span class="title"> 机器认证配置</span>
      <div>
        <el-checkbox v-model="list.whetherMacEmployee">是否关联员工</el-checkbox>
        <span style="color:orange;font-size:14px;">（勾选之后，员工只能在认证的机器上登录，别的电脑都不可登录）</span>
      </div>
    </div>
    <div class="systemSet_item">
      <span class="title"> 登录设置</span>
      <div>
        <el-checkbox-group v-model="list.openType">
          <el-checkbox label="APP">客户端登录</el-checkbox>
          <el-checkbox label="BROWSER">浏览器端登录</el-checkbox><span style="color:orange;font-size:14px;">（勾选之后，无法验证MAC地址）</span>
        </el-checkbox-group>
      </div>
    </div>
    <div class="systemSet_item">
      <span class="title">图片压缩比例</span>
      <div>
        <el-input-number v-model="list.picZipProportion" :min="0" :max="100" placeholder="请输入" controls-position="right" size="mini" />%
      </div>
    </div>
    <div class="systemSet_item">
      <span class="title"> 其他设置</span>
      <div class="items">
        <el-checkbox v-model="list.whetherOpen">启用</el-checkbox>
        <el-input v-model="list.defaultMinute" placeholder="请输入" @input="list.defaultMinute=list.defaultMinute.replace(/[^\d]/g, '');" />
        <span style="font-size:14px;">分钟不操作系统，会自动退出</span>
      </div>
      <div class="items" style="margin-top:20px;">
        <el-checkbox v-model="list.whetherRemind">官网/微站委托消息提醒</el-checkbox>
        <el-select v-model="remindEmployee" filterable placeholder="请选择员工" @change="checkItem">
          <el-option v-for="(item,index) in remindEmployeeList" :key="index" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="items" style="margin-top:14px;">
        <div class="list_item" v-for="(item,index) in remindEmployeeName" :key="index" style="margin-bottom:20px;">
          <span class="list_item_title">{{item}}</span>
          <img src="../../assets/shanchu.png" alt="删除" class="list_item_img" @click="delectItem(index)">
        </div>
      </div>
    </div>

    <el-button @click="save" type="primary" v-points>保存</el-button>
  </div>
</template>

<script>
import {
  queryWebsiteCompany,
  updateWebsiteMacSet,
  queryCommon
} from "@/api/systemSetup";
export default {
  data() {
    let permisList = JSON.parse(sessionStorage.getItem("permisList"));
    return {
      permisList,
      remindEmployee: "",
      options: [
        { value: "YES", text: "是" },
        { value: "NO", text: "否" }

      ],
      remindEmployeeList: [],
      remindEmployeeName: [],
      list: {
        whetherMacEmployee: false,
        openType: [],
        whetherOpen: false,
        defaultMinute: "",
        whetherRemind: false,
        remindEmployee: [],
        area: "",
        matchingDegree:"",
        picZipProportion: 0,
      }
    };
  },
  mounted() {
    this.getDetail(); //获取详情
    this.getRemindEmployee(); //获取所有员工
  },

  methods: {
    permisShow(data) {
      // 权限配置
      let result = this.permisList.indexOf(data);
      if (result >= 0) {
        return true;
      } else {
        return false;
      }
    },
    //获取设置详情
    getDetail() {
      this.$post(queryWebsiteCompany).then(res => {
        if (res.success) {
          this.list.whetherMacEmployee = res.data.whetherMacEmployee;
          this.list.whetherOpen = res.data.whetherOpen;
          this.list.defaultMinute = res.data.defaultMinute;
          this.list.whetherRemind = res.data.whetherRemind;
          this.list.remindEmployee = res.data.remindEmployee;
          this.list.picZipProportion = res.data.picZipProportion;
          this.list.area = res.data.area;
          this.list.matchingDegree = res.data.matchingDegree
          this.remindEmployeeName = res.data.remindEmployeeNames;
          if (res.data.openType) {
            this.list.openType = res.data.openType.split(",");
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //获取所有员工
    getRemindEmployee() {
      let params = {
        type: "ALL"
      };
      this.$post(queryCommon, params).then(res => {
        if (res.success) {
          this.remindEmployeeList = res.data.allEmployeeNames;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //选中员工
    checkItem(id) {
      if (this.list.remindEmployee.indexOf(id) > -1) {
        this.$message({
          type: "error",
          message: "该员工已存在"
        });
      } else {
        this.remindEmployeeList.map((item, index) => {
          if (item.id == id) {
            this.list.remindEmployee.push(item.id);
            this.remindEmployeeName.push(item.name);
          }
        });
      }
    },
    //删除提醒员工
    delectItem(index) {
      this.list.remindEmployee.splice(index, 1);
      this.remindEmployeeName.splice(index, 1);
    },
    //提交
    save() {
      let params = Object.assign({}, this.list);
      console.log(/^([6-9]\d|100)$/.test( params.matchingDegree));
      if (!/^([6-9]\d|100)$/.test( params.matchingDegree)) {
        this.$message.error('房客源匹配度的值配置范围为60~100之间的正整数');
        return;
      }

      if (params.openType.length != 0) {
        params.openType = params.openType.join(",");
      }
      if (params.remindEmployee.length != 0) {
        params.remindEmployee = params.remindEmployee.join(",");
      }
      this.$post(updateWebsiteMacSet, params).then(res => {
        if (res.success) {
          this.$message.success(res.msg);
          this.getDetail(); //获取详情
        } else {
          this.$message.error(res.msg);
        }
      });
    }
  }
};
</script>

<style lang='less'>
.systemSet {
  background: #fff;
  height: 80vh;
  padding: 0 20px;
  .el-input__inner {
    height: 30px;
    line-height: 30px;
  }
  .el-button {
    background: #5e75e6;
    width: 160px;
    display: block;
    margin: 20px auto;
  }
  .systemSet_item {
    .title {
      line-height: 50px;
      font-weight: bold;
    }
    .el-checkbox-group {
      margin: 0;
    }
    .items {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .el-input {
        width: 100px;
        margin: 0 10px;
        .el-input__inner {
          height: 30px;
          line-height: 30px;
        }
      }
      .el-select {
        .el-input {
          width: 120px;
          .el-input__inner {
            height: 30px;
            line-height: 30px;
          }
          .el-input__icon {
            height: 30px;
            line-height: 30px;
          }
        }
      }
      .list_item {
        margin: 0 12px;
        position: relative;
        .list_item_title {
          font-size: 14px;
        }
        .list_item_img {
          position: absolute;
          top: -7px;
          right: -14px;
        }
      }
    }
  }
}
</style>